import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
    dialogContent: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        width: '100%',
    },
    dialogPaper: {
        width: '72vw',
        minWidth: '900px',
        maxWidth: '1150px !important',
        maxHeight: '90vh',
        margin: '16px',
        '@media (max-width: 950px)': {
            minWidth: 'auto',
            width: 'calc(100% - 24px)',
            margin: '12px',
        },
    },
    box: {
        display: 'flex',
        flexFlow: 'column',
        height: '100%',
    },
    header: {
        flex: '0 1 auto',
        display: 'flex',
        padding: '15px 10px',
        alignItems: 'baseline',
        cursor: 'move',
        backgroundColor: '#454545',
        justifyContent: 'space-between',
    },
    title: {
        fontFamily: 'Lato',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    content: {
        marginBottom: '12px',
        padding: '12px 20px',
    },
    container: {
        padding: '6px 0px',
    },
    historyTableWrapper: {
        width: '100%',
        minHeight: '190px',
        maxHeight: '420px',
        overflow: 'auto',
        '& .custom-grid': {
            minWidth: '1370px',
        },
        '& .ant-table-cell': {
            padding: '8px 10px',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            fontSize: '13px',
        },
        '& .ant-table-thead > tr > th': {
            fontWeight: 600,
            verticalAlign: 'middle',
        },
        '& .ant-table-tbody > tr > td:nth-child(8)': {
            whiteSpace: 'normal',
            minWidth: '160px',
            lineHeight: '18px',
        },
        '& .ant-tag': {
            whiteSpace: 'nowrap',
        },
    },
    footer: {
        flex: '0 1 40px',
        padding: '12px 20px',
        background: '#F8F9FB',
    },
    footerRight: {
        float: 'right',
    },
    backBtn: {
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#0049A3',
        borderRadius: '4px',
        padding: '8px 16px',
        textTransform: 'uppercase',
        border: '1px solid #0049A3',
    },
}));
